module.exports = __webpack_public_path__ + "static/06-3-e47719fc8e28d4805240375941532069.jpg";